import { Link, tokens, Typography } from '@sapphire-react/core';
import { useTranslation } from 'react-i18next';

const CreateSectionContent = () => {
  const { t } = useTranslation();

  return (
    <>
      <Typography.Body marginBottom={tokens.size.spacingMd}>
        {t('moreInformation.thingsToConsider.paragraph1')}
      </Typography.Body>
      <Typography.Body marginBottom={tokens.size.spacingMd}>
        {t('moreInformation.thingsToConsider.paragraph2')}
      </Typography.Body>
      <Typography.Body>
        {t('moreInformation.thingsToConsider.paragraph3.mortgageInfo')}
        <Link UNSAFE_style={{ display: 'inline' }}>
          <a
            target={'_blank'}
            rel={'noopener noreferrer'}
            href={t(
              'moreInformation.thingsToConsider.paragraph3.loanApplicationUrl',
            )}
          >
            {t('moreInformation.thingsToConsider.paragraph3.loanApplication')}
          </a>
        </Link>
        {t('moreInformation.thingsToConsider.paragraph3.followUp')}
      </Typography.Body>
    </>
  );
};

export const thingsToConsider = {
  key: 'things-to-consider-data',
  text: 'moreInformation.thingsToConsider.title',
  content: <CreateSectionContent />,
};
